// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"SectionContainer_titleContainer__3l708","label":"SectionContainer_label__1D52M","contentContainer":"SectionContainer_contentContainer__1hZm4"};